import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'baseline-density-large', 'IconBaselineDensityLarge', [["path",{"d":"M4 4h16","key":"svg-0"}],["path",{"d":"M4 20h16","key":"svg-1"}]]);